import type { EditorState } from '@atlaskit/editor-prosemirror/state';

export interface HeadingContext {
	cursorInHeading: boolean;
	headingLevel: number;
	headingPos: number;
	headingText: string;
}

/**
 * Inspects the current selection and returns whether the cursor is inside a
 * heading node, and if so, what the heading's absolute document position and
 * text content are.
 */
export function getHeadingContext(state: EditorState): HeadingContext {
	const { $from } = state.selection;
	const parent = $from.parent;

	if (parent.type !== state.schema.nodes.heading) {
		return { cursorInHeading: false, headingPos: -1, headingText: '', headingLevel: 0 };
	}

	// $from.before($from.depth) gives us the absolute position of the start of
	// the heading node (the opening token position).
	const headingPos = $from.before($from.depth);
	const headingText = parent.textContent.trim();
	const headingLevel: number = parent.attrs['level'] ?? 1;

	return { cursorInHeading: true, headingPos, headingText, headingLevel };
}
